export default {
  title: 'لوحة التحكم',
  totalInvoices: 'إجمالي الفواتير',
  totalAmount: 'المبلغ الإجمالي',
  totalOrders: 'إجمالي الطلبات',
  totalShipForMe: 'إجمالي شحن لي',
  totalRevenue: 'إجمالي الإيرادات',
  averageOrderValue: 'متوسط قيمة الطلب',
  invoiceStatus: 'حالة الفاتورة',
  invoiceAmount: 'توزيع مبلغ الفاتورة',
  orderStatus: 'توزيع حالة الطلب',
  orderTypes: 'توزيع أنواع الطلبات',
  revenue: 'الإيرادات',
  revenueOverTime: 'الإيرادات عبر الوقت',
  statistics: 'الإحصائيات',
  summary: 'الملخص',
  charts: 'الرسوم البيانية',
  loading: 'جاري تحميل لوحة التحكم...',
  error: 'خطأ في تحميل لوحة التحكم',
  noData: 'لا توجد بيانات متاحة',
  iqdExchangeRate: 'سعر الدينار العراقي',
  iqdExchangeRateDate: 'آخر تحديث',
  iqdExchangeRateNotAvailable: 'غير متوفر',
};

